import React from "react";
import { DocumentRenderer } from "components";
import { Trans } from "react-i18next";
import withData from "./withData";
import HeaderData from "./HeaderData";
import CurrencyConversion from "./CurrencyConversion";
import LineItems from "./LineItems";
import { convertUTCToLocal, getStyle, LAYOUT_COMPONENTS_MAP } from "services/util";
import HeaderImage from "./InvoiceHeaders/HeaderImage";

export const SimpleInvoiceDocument = ({
  item,
  contact,
  settings,
  organisation,
  taxRates,
  history,
  t,
  qrCode,
  ...props
}) => {

  const { template_id } = item

  const defaultLayoutSettings = settings?.invoice_layout_settings?.find(x => x.id === template_id || (template_id === null && x.is_default === true))
  
  let Header = LAYOUT_COMPONENTS_MAP[defaultLayoutSettings?.layout] || LAYOUT_COMPONENTS_MAP.default

  let baseStyle = { fontSize: (defaultLayoutSettings?.font_size || settings.font_size_base || 16) + 'px' }

  const headerLogoStyle = getStyle(defaultLayoutSettings?.header_logo_style)
  const footerLogoStyle = getStyle(defaultLayoutSettings?.footer_logo_style)
  const invoiceLogoStyle = getStyle(defaultLayoutSettings?.invoice_logo_style)
  const invoiceTitleStyle = getStyle(defaultLayoutSettings?.invoice_title_style)
  const invoiceLabelStyle = getStyle(defaultLayoutSettings?.invoice_label_style)
  const invoiceContentStyle = getStyle(defaultLayoutSettings?.invoice_content_style)
  const lineItemHeaderStyle = getStyle(defaultLayoutSettings?.line_item_header_style)
  const lineItemStyle = getStyle(defaultLayoutSettings?.line_item_style)
  const subtotalLineStyle = getStyle(defaultLayoutSettings?.subtotal_line_style)
  const taxLineStyle = getStyle(defaultLayoutSettings?.tax_line_style)
  const totalLineStyle = getStyle(defaultLayoutSettings?.total_line_style)

  const header = defaultLayoutSettings?.header || settings.header
  const footer = defaultLayoutSettings?.footer || settings.footer
  const footer_english = defaultLayoutSettings?.footer_english || settings.footer_english
  const logo = defaultLayoutSettings?.logo || settings.logo

  if (defaultLayoutSettings) {
    if (defaultLayoutSettings?.font_family) {
      baseStyle = { ...baseStyle, fontFamily: defaultLayoutSettings?.font_family }
    }

    if (defaultLayoutSettings?.font_color) {
      baseStyle = { ...baseStyle, color: defaultLayoutSettings?.font_color }
    }

    if (footerLogoStyle) {
      if (footerLogoStyle.display !== 'none' && footerLogoStyle.height && defaultLayoutSettings.footer_logo) {
        baseStyle = { ...baseStyle, paddingBottom: footerLogoStyle.height }
      }
    }

  }

  return (
    <DocumentRenderer {...props}>

      <div className="container-fluid my-3" style={{ ...baseStyle, position: 'relative', }} >

        <HeaderImage value={defaultLayoutSettings?.header_logo} invoiceLogoStyle={headerLogoStyle} />

        <Header
          item={item}
          company={organisation}
          client={contact}
          taxRates={taxRates}
          t={t}
          settings={settings}
          doc_name={'Simplified Tax Invoice'}
          hideAttention={true}
          logo={logo}
          taxed={false}
          qrCode={qrCode}
          defaultLayoutSettings={defaultLayoutSettings}
          invoiceLogoStyle={invoiceLogoStyle}
          invoiceTitleStyle={invoiceTitleStyle}
          invoiceLabelStyle={invoiceLabelStyle}
          invoiceContentStyle={invoiceContentStyle}
          header={header}
        >
          <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Date" value={item.DateString} />
          <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Time" value={convertUTCToLocal(item.UpdatedDateUTC)} />
          <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Invoice Number" value={item.InvoiceNumber} />
          <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Reference" value={item.Reference} />
          <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Supply Date" value={item.ExpectedPaymentDateString?.substr(0, 10)} />
          {item.Status === 'VOIDED' && <HeaderData invoiceLabelStyle={invoiceLabelStyle} invoiceContentStyle={invoiceContentStyle} className="mb-1" label="Status" value={'Voided (from Xero)'} />}
        </Header>

        <LineItems 
          invoice={item} 
          taxRates={taxRates} 
          includeDiscount 
          history={history}
          organisation={organisation}
          lang={props.language} 
          lineItemHeaderStyle={lineItemHeaderStyle}
          lineItemStyle={lineItemStyle}
          subtotalLineStyle={subtotalLineStyle}
          taxLineStyle={taxLineStyle}
          totalLineStyle={totalLineStyle}
        />

        <CurrencyConversion item={item} organisation={organisation} />
        <div className="font-weight-bold mt-3 mb-2">
          <Trans>Due Date: </Trans> {item.DueDateString}
        </div>
        {footer ? (
          <div style={{ whiteSpace: "pre-line" }} className="mt-1 rtl" dir="rtl">
            {footer}
          </div>
        ) : null}
        {footer_english ? (
          <div style={{ whiteSpace: "pre-line" }} className="mt-1 ltr" dir="ltr">
            {footer_english}
          </div>
        ) : null}

        {/* <FooterImage value={defaultLayoutSettings?.footer_logo} invoiceLogoStyle={footerLogoStyle} /> */}

      </div>
    </DocumentRenderer>
  )
};

export default withData(SimpleInvoiceDocument);
